import { mapGetters } from "vuex";
import VueCookies from 'vue-cookies'

export const print_config = {
  computed: {
    ...mapGetters(["table_config"]),
  },
  methods: {
    loadPrintConfig() {
      let item = this.loadPrintPrivateConfig();
      if (!item || !item.use) {
        item = this.loadPrintGlobalConfig();
      }
      return item;
    },
    loadPrintGlobalConfig() {
      return this.table_config.find(c => c.key === 'print');
    },
    loadPrintPrivateConfig() {
      let data = VueCookies.get("print");
      return data;
    },
    updatePrintGlobalConfig(data, handler) {
      this.disablePrintPrivateConfig();
      let params ={
        key: 'print',
        value: data
      };
      this.api.updateConfig(params).then(res => {
        handler(res);
      });
    },
    updatePrintPrivateConfig(data, use=true) {      
      let params ={
        use: use,
        value: data
      };
      let string = JSON.stringify(params);
      VueCookies.set("print", string, -1);
    },
    disablePrintPrivateConfig() {
      let data = this.loadPrintPrivateConfig();
      if (!data) { return; }
      this.updatePrintPrivateConfig(data.value, false);
    },
  }
}